import React from 'react'
import { WemoloLicensePlate, WemoloTypography } from '../../../components/Wemolo'
import { DETECTION_EXPLORER_TEXT } from '../config'
import { DetectionsEmptyState } from '../EmptyState'
import { GalleryCard, GalleryItem } from '../Gallery'
import styles from './GroupByLP.module.css'

export type PlateGroup = {
    plate: string
    latestTimestamp: Date
    items: GalleryItem[]
}

export type GroupByLPUIProps = {
    groups: PlateGroup[]
    selectedIds: string[]
    onToggleSelect: (id: string) => void
    onOpenDetail: (id: string) => void
}

const plateCountry = (group: PlateGroup): GalleryItem['country'] => group.items[0]?.country ?? 'INT'

export const GroupByLPUI: React.FC<GroupByLPUIProps> = ({ groups, selectedIds, onToggleSelect, onOpenDetail }) => {
    if (groups.length === 0) {
        return <DetectionsEmptyState />
    }

    return (
        <div className={styles.groupList}>
            {groups.map((group) => (
                <section key={group.plate} className={styles.group}>
                    <header className={styles.groupHeader}>
                        <WemoloLicensePlate plateNumber={group.plate} size="small" country={plateCountry(group)} />
                        <WemoloTypography variant="body-small" tag="span" className={styles.headerMeta}>
                            {group.items.length}{' '}
                            {group.items.length === 1
                                ? DETECTION_EXPLORER_TEXT.groupByLP.detection
                                : DETECTION_EXPLORER_TEXT.groupByLP.detections}{' '}
                            · {DETECTION_EXPLORER_TEXT.groupByLP.latest} {group.latestTimestamp.toLocaleString()}
                        </WemoloTypography>
                    </header>
                    <div className={styles.cardRow}>
                        {group.items.map((item) => (
                            <GalleryCard
                                key={item.id}
                                item={item}
                                isSelected={selectedIds.includes(item.id)}
                                onToggleSelect={onToggleSelect}
                                onOpenDetail={onOpenDetail}
                            />
                        ))}
                    </div>
                </section>
            ))}
        </div>
    )
}
